<template>
    <ExportDownload :initial-state="initialState" :error-message="errorMessage" />
</template>

<script setup lang="ts">
import type { ExportRunStatus, ExportRecordSummary } from '@coldreach/campaigns';

type ExportRecord = Omit<ExportRecordSummary, 'createdAt'> & { createdAt: Date | string };
type ExportState = Exclude<ExportRunStatus, { status: 'ready' }>
    | { status: 'ready'; runId?: string; record: ExportRecord };

const props = defineProps<{
    part: {
        type: string;
        state?: string;
        output?: unknown;
        errorText?: string;
        [key: string]: unknown;
    };
}>();

// Chat remounts tool cards when the SDK publishes their output.
const initialState = props.part.output as ExportState | undefined;
const errorMessage = computed(() => props.part.errorText
    || (props.part.state === 'output-error' ? 'The export could not be prepared.' : ''));
</script>
